module.exports = __webpack_public_path__ + "static/media/ico-shield.1011f51a.svg";